
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const BookmarkIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M16 17C16 13.134 19.134 10 23 10H73C76.866 10 80 13.134 80 17V78.9769C80 84.9287 73.0436 88.1651 68.4911 84.3313L48 67.0757L27.509 84.3313C22.9564 88.1651 16 84.9287 16 78.9769V17ZM73 17H23V78.9769L43.4911 61.7213C46.0966 59.5271 49.9034 59.5272 52.5089 61.7213L73 78.9769V17Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.5 17V78.9769C19.5 81.9528 22.9782 83.571 25.2545 81.6541L45.7455 64.3985C47.0483 63.3014 48.9517 63.3014 50.2545 64.3985L70.7455 81.6541C73.0218 83.571 76.5 81.9528 76.5 78.9769V17C76.5 15.067 74.933 13.5 73 13.5H23C21.067 13.5 19.5 15.067 19.5 17Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M16 17C16 13.134 19.134 10 23 10H73C76.866 10 80 13.134 80 17V78.9769C80 84.9287 73.0436 88.1651 68.4911 84.3313L48 67.0757L27.509 84.3313C22.9564 88.1651 16 84.9287 16 78.9769V17ZM73 17H23V78.9769L43.4911 61.7213C46.0966 59.5271 49.9034 59.5272 52.5089 61.7213L73 78.9769V17Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.5 17V78.9769C19.5 81.9528 22.9782 83.571 25.2545 81.6541L45.7455 64.3985C47.0483 63.3014 48.9517 63.3014 50.2545 64.3985L70.7455 81.6541C73.0218 83.571 76.5 81.9528 76.5 78.9769V17C76.5 15.067 74.933 13.5 73 13.5H23C21.067 13.5 19.5 15.067 19.5 17Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
